export default function GetFormattedNumber(phone){
  if (!phone) {
    return '';
  }
  let phoneNumber = String(phone);
  let phoneNumberString = phoneNumber.replaceAll('-', "").replace('(', "").replaceAll(' ', '').replace(')', "");
  let firstPart = phoneNumberString.substring(0, 3);
  let secondPart = phoneNumberString.substring(3, 6);
  let lastPart = phoneNumberString.substring(6, 10);
  return `(${firstPart}) ${secondPart}-${lastPart}`
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/StringToPhoneNumber.js